import { DehydratedState, QueryClient } from '@tanstack/react-query';

import { IServerSideState } from '../../types/serverSideState';

export class ServerSideState implements IServerSideState {
  public readonly queryClient: QueryClient;
  public dehydratedState: DehydratedState;

  public constructor(queryClient: QueryClient, dehydratedState: DehydratedState) {
    this.queryClient = queryClient;
    this.dehydratedState = dehydratedState;
  }
}
